import { Columns } from "./columns";
import { ReportConfigBase } from "../index";
import { EReportTypes } from "../../routes/report_types";

const DashboardNoteReportConfig: ReportConfigBase = {
  type: EReportTypes.DashboardNote,
  endpoint: "note",
  reportKey: "notes",
  filtersBase: [],
  summaryBase: [],
  columnsBase: Columns,
  withSelection: false,
  intro: {
    description:
      "The Dashboard Note Report provides detailed information about a rep's notes",
    url: "https://help.commonsku.com/knowledge/sales-dashboard-report",
  },
};

export default DashboardNoteReportConfig;
